var _rect, _path, _rect2, _g, _rect3, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLibraryEmptyState(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 147,
    viewBox: "0 0 286 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101.5,
    y: 11.5,
    width: 85,
    height: 85,
    rx: 15.5,
    fill: "#F6F7F9",
    stroke: "#E5E7EA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M125.666 54h36.667m-36.667-9.167h9.167m18.333 0h9.167m-36.667 18.334h9.167m18.333 0h9.167m-27.5 9.166V35.667m18.333 36.666V35.667m-18.7 36.666h19.067c3.08 0 4.62 0 5.797-.6a5.497 5.497 0 002.403-2.403c.6-1.176.6-2.716.6-5.797V44.467c0-3.08 0-4.62-.6-5.797a5.497 5.497 0 00-2.403-2.404c-1.177-.6-2.717-.6-5.797-.6h-19.067c-3.08 0-4.62 0-5.797.6a5.504 5.504 0 00-2.404 2.404c-.599 1.176-.599 2.716-.599 5.797v19.066c0 3.08 0 4.62.599 5.797a5.504 5.504 0 002.404 2.404c1.177.6 2.717.6 5.797.6z",
    stroke: "#CED2D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12.612,
    y: 52.354,
    width: 85,
    height: 85,
    rx: 15.5,
    transform: "rotate(-15 12.612 52.354)",
    fill: "#F6F7F9",
    stroke: "#E5E7EA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#library_empty_state_svg__clip0_664_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.4 100.679l8.552-14.811c.513-.89.77-1.334 1.139-1.574.325-.21.708-.313 1.095-.293.439.023.884.28 1.773.793l14.713 8.495M68.909 85.92l3.719-6.441c.513-.89.77-1.334 1.14-1.573.324-.211.707-.314 1.094-.294.44.023.884.28 1.773.793l6.441 3.72M58.98 77.192a3.667 3.667 0 11-7.084 1.898 3.667 3.667 0 017.084-1.898zm.027 22.769l18.417-4.935c2.975-.797 4.463-1.196 5.444-2.08a5.5 5.5 0 001.7-2.943c.274-1.292-.124-2.78-.921-5.755L79.66 69.374c-.797-2.975-1.196-4.463-2.08-5.444a5.5 5.5 0 00-2.944-1.7c-1.291-.274-2.779.124-5.754.921l-18.417 4.935c-2.975.797-4.463 1.196-5.444 2.08a5.5 5.5 0 00-1.7 2.943c-.274 1.292.124 2.78.922 5.755l3.985 14.875c.797 2.975 1.196 4.463 2.08 5.444a5.494 5.494 0 002.943 1.7c1.292.275 2.78-.124 5.755-.921z",
    stroke: "#CED2D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 191.436,
    y: 30.612,
    width: 85,
    height: 85,
    rx: 15.5,
    transform: "rotate(15 191.436 30.612)",
    fill: "#F6F7F9",
    stroke: "#E5E7EA"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#library_empty_state_svg__clip1_664_1293)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.798 66.662l-1.96 7.315c-.266.992-.399 1.487-.308 1.918.081.379.279.722.567.981.327.295.823.428 1.815.694l7.314 1.96m-8.978 7.084l-14.167-3.797m12.269 10.88L212.183 89.9m7.337-13.218l-3.541-.949m13.946-9.549l-9.208-2.468c-2.975-.797-4.463-1.195-5.755-.92a5.498 5.498 0 00-2.943 1.699c-.884.981-1.283 2.469-2.08 5.444l-4.935 18.417c-.797 2.975-1.195 4.463-.921 5.755a5.498 5.498 0 001.7 2.943c.981.884 2.469 1.283 5.444 2.08l11.333 3.037c2.976.797 4.463 1.195 5.755.921a5.499 5.499 0 002.944-1.7c.883-.981 1.282-2.469 2.079-5.444l4.366-16.292-7.779-13.472z",
    stroke: "#CED2D6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "library_empty_state_svg__clip0_664_1293"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(-15 269.16 -107.521)",
    d: "M0 0h44v44H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "library_empty_state_svg__clip1_664_1293"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "rotate(15 -109.64 810.674)",
    d: "M0 0h44v44H0z"
  })))));
}
export default SvgLibraryEmptyState;